export default class SlideOut {
    constructor(modal, config = {}) {
        this.modal = modal;
        this.config = config;
        this.body = document.querySelector('body');
        this.openingElement = null;
    }

    open(openingElement) {
        this.openingElement = openingElement;
        this.modal.classList.add('slide-out--open');
        this.modal.ariaHidden = 'false';
        this.body.style.overflow = 'hidden';
        this.modal.querySelector('.slide-out__close').focus();
        this.modal.querySelector('.slide-out__close').addEventListener('click', () => {
            this.close();
        });
    }

    close() {
        this.modal.classList.remove('slide-out--open');
        this.modal.ariaHidden = 'true';
        this.body.style.overflow = '';

        if (this.config.onClose) {
            this.config.onClose();
        }

        this.openingElement.focus();
    }
}
